import * as React from "react";
import Spin from "antd/es/spin";
import Flex from "antd/es/flex";
import { useAvailable } from "../api";
import { ExchangeToken, ReservesType } from "./types";

export interface ReservesProps {
    token: ExchangeToken;
    children: (reserves?: ReservesType) => React.ReactNode;
}

export const Reserves: React.FunctionComponent<ReservesProps> = (props) => {
    const reserves = useAvailable(props.token);
    if (reserves.isLoading) {
        return <Spin />
    }
    return (
        <Flex vertical gap="20px">
            {props.children(reserves.data)}
        </Flex>
    );
};